import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { UserAvatarComponent } from '../../user-avatar/user-avatar.component';
import { environment } from '../../../../../environments/environment';

import { User } from '../../../types/user.model';
import { RankBadgeComponent } from '../../rank-badge/rank-badge.component';
import { ThousandsSeparatorPipe } from '../../../pipes/thousands-separator.pipe';

@Component({
  selector: 'app-my-special-forest',
  standalone: true,
  imports: [TranslateModule, UserAvatarComponent, RankBadgeComponent, ThousandsSeparatorPipe],
  templateUrl: './my-special-forest.component.html',
  styleUrl: './my-special-forest.component.scss'
})
export class MySpecialForestComponent {
  @Input() forestMembers: any[] = [];
  @Input() pageOffset: number = 0;
  @Output() membersClick: EventEmitter<any> = new EventEmitter();
  public environment: typeof environment = environment;

  public getInitials(forestMemeber: any): string {
    const { first_name, last_name } = forestMemeber;
    return [first_name, last_name].map((name: string) => name?.charAt(0)?.toUpperCase() || '').join('');
  }

  public getAvatarUrl(forestMemeber: any): string {
    if (!forestMemeber?.avatar?.image) {
      return '';
    }
    return environment.avatarsUrl + 'Property_1=' + forestMemeber?.avatar?.image;
  }

  public onMemberClick(forestMember: User): void {
    this.membersClick.emit(forestMember);
  }
}
